import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation RemoveOrdersFromDispatchTrack(
    $input: RemoveOrdersFromDispatchTrackInput!
  ) {
    removeOrdersFromDispatchTrack(input: $input) {
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/removeOrdersFromDispatchTrack.js